export default __webpack_public_path__ + "static/media/bg-risk.44e7f40c.png";